export default [{
  path: '/explanatoryLetter',
  name: 'explanatoryLetter',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/explanatoryLetter/index')
}]
